import React, {Fragment, useEffect, useRef, useState} from "react";
import {makeStyles} from "@material-ui/core/styles";
import {isLink, isMail, isPhone} from "../../utils/helper/TextHelper";
import {Colors} from "../helper/ColorHelper";
import Mention from "../../utils/models/Mention";
import RenderedMention, {mentionWithFormatting} from "../mention/RenderedMention";
import Quill from "quill";
import 'quill/dist/quill.snow.css';
import QuillEditor from "../article/QuillEditor";

const useStyles = makeStyles((theme) => ({
    link: {
        textDecoration: 'none',
        color: Colors.BRANDSECONDARY
    }
}));

const MoinLinkifiedText = ({text = ""}) => {
    const classes = useStyles();

    const wordRegex = RegExp(/(?=\s(?!\d*\s))/); // |(?<=]}!!)/); <-- this does not work on safari (thank you apple)

    let mentionSplit = text.split(']}!!');

    for(let i = 0; i < mentionSplit.length-1; i++) {
        mentionSplit[i] += ']}!!';
    }

    let words = mentionSplit.map(e => e.split(wordRegex)).flat();

    words = words.map( (word, index) => {
        let trimmedWord = word.trim();

        if (isLink(trimmedWord)) {
            let prefix = "http://";
            trimmedWord = trimmedWord.replace('http://', '');
            if (trimmedWord.includes('https://')) {
                trimmedWord = trimmedWord.replace('https://', '');
                prefix = "https://";
            }
            return <a key={index} href={prefix + trimmedWord} target={'blank'} className={classes.link}>{word}</a>
        } else if (isPhone(trimmedWord)) {
            return <a key={index} href={'tel:' + trimmedWord} className={classes.link}>{word}</a>
        } else if (isMail(trimmedWord)) {
            return <a key={index} href={'mailto:' + trimmedWord} className={classes.link}>{word}</a>
        } else if(Mention.isMentionString(trimmedWord)) {
            let mention = Mention.fromMentionString(trimmedWord);
            return <RenderedMention key={index} mention={mention}/>
        }
        return <span key={index}>{word}</span>;
    })

    return (
        <>
            {words}
        </>
    );
}

const MoinFormattedLinkifiedText = ({text = "", className = "", onClick, shortened = false}) => {
    const classes = useStyles();
    const Delta = Quill.import('delta');
    const quillRef = useRef();

    const [initialValue, setInitialValue] = useState(() => {
        let delta;

        if (text) {
            try {
                if (typeof text === 'string' && ((text.startsWith('{') && text.endsWith('}')) || (text.startsWith('[') && text.endsWith(']')))) {
                    let parsedText = JSON.parse(text);

                    for (let textSegment of parsedText) {
                        if(textSegment.hasOwnProperty('attributes')) {
                            delete textSegment.attributes['font'];
                            delete textSegment.attributes['color'];
                            delete textSegment.attributes['size'];
                        }
                    }

                    delta = new Delta(parsedText);
                } else {
                    delta = new Delta().insert(String(text));
                }
            } catch {
                delta = new Delta().insert(String(text));
            }
        } else {
            delta = new Delta();
        }

        if (!shortened) {
            return delta;
        }

        const totalLen = delta.length();

        if (totalLen <= 220) {
            return delta;
        }

        return delta.slice(0, 220).insert('...');

    });

    return <div className={classes.wrapper}>
        <QuillEditor
            ref={quillRef}
            readOnly={true}
            defaultValue={initialValue}
            placeholder=""
        />
    </div>;
}


export default MoinLinkifiedText;
export {MoinFormattedLinkifiedText};
